const TEMPLATE_ID = {
    DEFAULT_EMAIL: 'd-4b09d9c077b74c408660b4f5955a74e8',
    INVITE_TO_ANSWER: 'd-665563d9afa54c35af2c1d819d121d96',
    ACCEPT_POST: 'd-457b3288b6d44c3d9c49fd212a4b54d4',
    DECLINE_POST: 'd-320d28dd5e3d4fd2a044dc9fa4cac7a7',
    RECEIVE_MONEY_WITHOUT_STRIPE_ACCOUNT_EMAIL: 'd-a80bb8dcfd9a42a89edf5b67fbcbfce1',
    RECEIVE_MONEY_EMAIL: 'd-c9655c3f3f6641039417e5b9156ea8f4',
    NEW_REVIEW: 'd-aeacfd8befc1414eafeeb77543577bb7',
    CONFIRM_EMAIL: 'd-392b4b0f7d934a5daf5c1e6aec033946',
    HIRE_FREELANCER: 'd-a397a1d3af184415ab3e90cd7cace57d',
    NOT_HIRE_FREELANCER: 'd-95eff30c65904c99a80f5456ee9f9237',
    REQUEST_INVOICE: 'd-35f6f01d9abc41d9af5c8e1e20ebfee7',
    COMPLETE_PROJECT: 'd-adaa29b8b3cd4f558fa2216ff78e4464',
    FIRST_ANSWER_TO_INVITE: 'd-6c8f79cf836f4cc2bd421c5685ca91a7',
    DELETE_POST_FOR_INVITED: 'd-9c336b5d617940eaa93028eb28584bb0',
    DELETE_POST_FOR_HIRED: 'd-607019cc04cf483e884006ec492859a1',
    WEEKLY_REMINDER: 'd-c9df67784f294a1d9e07078e4c066cde',
    MONTHLY_REMINDER: 'd-d79f5e131ed74f878f1b96ffe8d7f06f',
};

module.exports.TEMPLATE_ID = TEMPLATE_ID;
